import { QRCodeCanvas } from "qrcode.react";
import { useRef } from "react";
import { Button } from "@/components/ui/button";
import { Printer, Download } from "lucide-react";
import { locString } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";
import { labelBrand, escapeHtml } from "@/lib/labelBrand";

function printLabel({ img, title, code, lines, brand }) {
  const w = window.open("", "_blank");
  if (!w) return;
  const extra = (lines || []).filter(Boolean).map((l) => `<div class="line">${escapeHtml(l)}</div>`).join("");
  const logo = brand.logo ? JSON.stringify(brand.logo) : "null";
  w.document.write(`<html><head><title>Etiqueta ${escapeHtml(code)}</title><style>
    body{font-family:Arial,sans-serif;margin:0;padding:20px;text-align:center}
    .label{display:inline-block;border:1px solid #cbd5e1;border-radius:10px;padding:16px;width:260px}
    .brand{display:flex;align-items:center;justify-content:center;gap:8px;border-bottom:2px solid #0F4C81;padding-bottom:6px;margin-bottom:8px}
    .brand img.logo{height:30px}.brand span{font-weight:800;color:#0F4C81;font-size:20px;letter-spacing:1px}
    .title{font-weight:bold;font-size:15px;margin:6px 0 2px}.code{font-family:monospace;font-size:16px;color:#0F4C81}
    .line{font-size:12px;color:#334155}img.qr{width:180px;height:180px;margin-top:8px}
  </style></head><body><div class="label">
    ${brand.hasBrand ? `<div class="brand">${brand.html}</div>` : ""}
    <div class="title">${escapeHtml(title)}</div><div class="code">${escapeHtml(code)}</div>${extra}
    <img class="qr" src="${img}"/>
  </div><script>const L=${logo};const go=()=>setTimeout(()=>window.print(),300);if(!L){go()}else{let i=new Image();i.onload=go;i.onerror=go;i.src=L;}</script></body></html>`);
  w.document.close();
}

export function QRLabel({ part }) {
  const user = useAuth()?.user;
  const ref = useRef(null);
  const value = `${window.location.origin}/pecas/${part.id}`;
  const canvas = () => ref.current?.querySelector("canvas");
  const download = () => { const c = canvas(); if (!c) return; const a = document.createElement("a"); a.href = c.toDataURL("image/png"); a.download = `qr-${part.codigo_interno}.png`; a.click(); };
  const print = () => printLabel({ img: canvas()?.toDataURL("image/png"), title: part.descricao, code: part.codigo_interno, lines: [locString(part.localizacao)], brand: labelBrand(user) });
  return (
    <div className="flex flex-col items-center gap-3">
      <div ref={ref} className="rounded-xl bg-white p-4"><QRCodeCanvas value={value} size={168} level="M" /></div>
      <div className="text-center"><div className="font-mono text-sm text-slate-200">{part.codigo_interno}</div><div className="text-xs text-slate-400">{part.descricao}</div><div className="text-xs text-slate-500">{locString(part.localizacao)}</div></div>
      <div className="flex gap-2">
        <Button data-testid="btn-qr-print" size="sm" variant="secondary" onClick={print}><Printer className="h-4 w-4 mr-1" /> Imprimir</Button>
        <Button data-testid="btn-qr-download" size="sm" variant="secondary" onClick={download}><Download className="h-4 w-4 mr-1" /> Baixar</Button>
      </div>
    </div>
  );
}

export function MachineQRLabel({ machine }) {
  const user = useAuth()?.user;
  const ref = useRef(null);
  const value = `${window.location.origin}/maquinas/${machine.id}`;
  const canvas = () => ref.current?.querySelector("canvas");
  const download = () => { const c = canvas(); if (!c) return; const a = document.createElement("a"); a.href = c.toDataURL("image/png"); a.download = `qr-${machine.equipment_id}.png`; a.click(); };
  const print = () => printLabel({ img: canvas()?.toDataURL("image/png"), title: machine.nome, code: machine.equipment_id, lines: [machine.localizacao || ""], brand: labelBrand(user) });
  return (
    <div className="flex flex-col items-center gap-3">
      <div ref={ref} className="rounded-xl bg-white p-4"><QRCodeCanvas value={value} size={168} level="M" /></div>
      <div className="text-center"><div className="font-mono text-sm text-sky-300">{machine.equipment_id}</div><div className="text-xs text-slate-400">{machine.nome}</div></div>
      <div className="flex gap-2">
        <Button data-testid="btn-machine-qr-print" size="sm" variant="secondary" onClick={print}><Printer className="h-4 w-4 mr-1" /> Imprimir</Button>
        <Button data-testid="btn-machine-qr-download" size="sm" variant="secondary" onClick={download}><Download className="h-4 w-4 mr-1" /> Baixar</Button>
      </div>
    </div>
  );
}
